<template>
  <multiselect 
    placeholder="Select Category"
    :options="categories.data" 
    label="name" 
    track-by="id" 
    :value="selected" 
    @input="handleInput" @remove="handleRemove" />
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'CategorySelect',

  components: {
    Multiselect
  },

  created () {
    this.getCategories()
  },

  props: ['value', 'type'],

  computed: {
    selected () {
      return this.categories.data.find(category => category.id === this.value)
    }
  },

  data () {
    return {
      categories: {
        data: []
      }
    }
  },

  methods: {
    async getCategories () {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/categories`, {
          params: {

          }
        })
        this.categories = data.categories
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },

    handleInput (value) {
      this.$emit('input', value.id)
    },

    handleRemove () {
      this.$emit('input', null)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>